<template>
  <div class="main">
    <el-table
      class="book-tabel"
      :data="dataList"
      :height="isShowStatus == true ? maxHeight - 60 : maxHeight - 30"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#274C9F',
        height: '40px',
        borderBottom: '10px solid #F8F8F8',
      }"
    >
      <el-table-column v-if="!isShowStatus" type="selection" width="50">
      </el-table-column>
      <el-table-column label="教材" prop="name">
        <template slot-scope="scope">
          <div class="material">
            <img v-if="scope.row.coverUrl" class="cover" :src="scope.row.coverUrl" />
            <img
            v-else
            class="cover"
            src="../../../assets/img/noimage.jpeg"
            alt=""
          />
            <div class="content">
              <div class="mat-title">{{ scope.row.teachName }}</div>
              <div class="content-text">作者：{{ scope.row.author }}</div>
              <div class="content-text">书号：{{ scope.row.isbn }}</div>
              <div class="content-text">
                出版社：{{ scope.row.publicationName }}
              </div>
              <div class="content-text">
                定价：<span class="content-text" style=" margin-left: 10px; color: #F62626;"
                  >¥{{ scope.row.pricing.toFixed(2) }}</span
                >
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="用书时间"
        align="center"
        width="200"
        prop="semesterName"
      >
    </el-table-column>
      <el-table-column
        label="用书课程"
        align="center"
        width="150"
        prop="courseName"
      >
      </el-table-column>
      <el-table-column
        label="用书班级(班级数量)"
        align="center"
        width="150"
        prop="classCnt"
      >
      </el-table-column>
      <el-table-column
        v-if="isShowStatus"
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <span class="status" :style="{ color: scope.row.statusColor }">
            {{ auditStatusObj[scope.row.auditStatus] }}
          </span>
          <p
            class="viewReason"
            v-if="scope.row.auditStatus == 3"
            @click="viewPerson(scope.row.id)"
          >
            查看原因
          </p>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.auditStatus == 3 || scope.row.isEidt"
            class="editbutton"
            @click="editBook(scope.row)"
          >
            编辑
          </span>
          <span class="delete" @click="deleteBookButton(scope.row)">
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="submit-mask" v-if="!isShowStatus">
      <div class="submit-bg">
        <el-checkbox v-model="checked" @change="isSelectedAll"
          >全选</el-checkbox
        >
        <div class="right-view">
          <span class="msg"
            >共选中教材
            <span style="color: #0082F0;">{{ multipleSelection.length }}</span>
            本</span
          >
          <div class="submit-btn" @click="submitAction()">提交清单</div>
        </div>
      </div>
    </div>
    <div class="mask-bg">
      <div class="submit-modal"></div>
    </div>
    <el-dialog
      :visible.sync="phonedialogVisible"
      width="550px"
      :before-close="handleClose"
      title="审核未通过原因"
    >
      <div class="bookDialog">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="content_form"
        >
          <template v-for="(item, index) in rejectReasonList">
            <el-form-item
              class="labelleft"
              :label="item.auditUserName + ':'"
              :key="index"
            >
              <span class="labelvalue commontext">{{ item.msg }}</span>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-dialog>
    <modelNew
      @close="close"
      v-if="showModel"
      :id="selectId"
      :pressId="pressId"
    ></modelNew>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import {
  verificationMaterialSheetInfo,
  deleteBook,
  updateBookList,
  rejectionReason,
} from '../../../api/wapi'
import { mapGetters } from 'vuex'
import modelNew from '../../common/modelNew.vue'
export default {
  props: ['dataList', 'isShowStatus', 'submitSuccess'],
  data() {
    return {
      maxHeight: document.documentElement.clientHeight-170,
      name: 'book-table',
      multipleSelection: [],
      checked: false,
      parList: [],
      auditStatusObj: {
        0: '未提交',
        1: '待审核',
        2: '审核通过',
        3: '审核不通过',
      },
      showModel: false,
      selectId: '',
      pressId: '',
      ruleForm: {
        oldpwd: '',
        password: '',
        passwordNew: '',
      },
      rules: {
        oldpwd: [{ required: true, trigger: 'blur', message: '请输入旧密码' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }],
        passwordNew: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
        ],
      },
      phonedialogVisible: false,
      rejectReasonList: [],
    }
  },
  components: {
    modelNew,
  },
  computed: {
    ...mapGetters(['resPhone']),
  },
  methods: {
    viewPerson(id) {
      rejectionReason({ id }).then((res) => {
        if (res.status == 0) {
          this.rejectReasonList = res.data;
        }
      })
      this.phonedialogVisible = true
    },
    phoneInfo() {
      this.phonedialogVisible = false
    },
    cancle() {
      this.phonedialogVisible = false
    },
    handleClose() {
      this.phonedialogVisible = false
    },
    close() {
      this.showModel = false
    },
    editBook(data) {
      if (data.auditStatus == 2) {
        this.$message.error('审核通过的书籍不能编辑')
        return
      }
      this.selectId = data.id
      this.pressId = data.pressId
      this.showModel = true
    },
    // 提交清单
    submitAction() {
      if (this.multipleSelection.length > 0) {
        let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0.5)' })
        let submitId = this.multipleSelection.map((item) => {
          return item.id
        })

        let ids = submitId.join(',')
        updateBookList({ ids: ids })
          .then((result) => {
            this.submitSuccess()
            this.$nextTick(() => {
              loadingInstance.close()
            })
          })
          .catch((err) => {
            this.$nextTick(() => {
              loadingInstance.close()
            })
          })
      } else {
        this.$message.error('请先选择要提交的教材')
      }
    },
    // 全选按钮事件
    isSelectedAll(e) {
      if (e == true) {
        for (let i = 0; i < this.dataList.length; i++) {
          this.$refs.multipleTable.toggleRowSelection(this.dataList[i], true)
        }
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (this.multipleSelection.length < this.dataList.length) {
        this.checked = false
      } else if (this.multipleSelection.length == this.dataList.length) {
        this.checked = true
      }
      if (this.multipleSelection.length == 0) {
        this.checked = false
      }
    },
    // 删除选书
    deleteBookButton(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteBook({ id: data.id }).then((res) => {
            if (res.status == 0) {
              this.$message.success('删除成功')
              const index = this.dataList.indexOf(data)
              if (index != -1) {
                this.$emit('deleteDone', index)
              }
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
  created() {},
}
</script>
<style>
.book-tabel  th> .cell{
  color: white !important;

}
.book-tabel{
  border: 0 !important;
  background-color: white;
}
.book-tabel .el-table__body{
  border: 0 !important;
}
.book-tabel tr{
  border: 0 !important;
}
.book-tabel td{
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #666666;
  border-bottom: 10px solid #f8f8f8 !important;
}
</style>
<style scoped>
.labelleft /deep/ label {
  text-align: left;
  text-indent: 20px;
}
.content_form {
  overflow-y: auto;
  height: 100%;
}
.bookDialog {
  height: 340px;
}
.bookDialog /deep/.el-form-item {
  margin-bottom: 10px !important;
}
.commonstylepass {
  height: 42px;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  line-height: 42px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
  width: 160px;
  float: left;
  cursor: pointer;
}
.loginBut {
  background: #0082F0;
  margin-left: 80px;
}
.cancle {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #000;
  margin-left: 20px;
}

.viewReason {
  font-family: '微软雅黑', sans-serif;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  color: #6860ae;
  cursor: pointer;
}
.editbutton {
  margin-right: 15px;
  cursor: pointer;
}
.book-tabel .el-table__body-wrapper::-webkit-scrollbar {
  width: 0;
}
.el-table th {
  background-color: #f8f8f8 !important;
}

</style>
<style scoped>
.status {
  color: #9a9a9a;
  font-size: 14px;
}
.delete {
  font-size: 14px;
  color: #666666;
  cursor: pointer;
}
.material {
  display: flex;
  padding:8px 40px;
}
.cover {
  width: 100px;
  height: 135px;
  object-fit: cover;
}
.content {
  margin: 0px 20px;
}
.el-table {
  border: 1px solid #e6e6e6;
  height: 100%--3.5rem;
}
.mat-title {
  font-size: 18px;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.content-text{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #666666;
  line-height: 24px;
}
.content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.submit-btn {
  background-color: #0082F0;
  color: white;
  height: 56px;
  text-align: center;
  line-height: 56px;
  width: 100px;
  cursor: pointer;
}
.msg {
  font-size: 13px;
  color: #333333;
  margin-right: 10px;
}
.main {
  background-color: white;
}
.mask-view {
  margin: 0px 60px;
}
.submit-bg {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
}
.right-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit-mask {
  position: absolute;
  display: flex;
  margin: 0 auto;
  width: 1200px;
  left: 0px;
  right: 0px;
  height: 56px;
  z-index: 0;
  background-color: white;
  -moz-box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
}

</style>